import { RouteRecordRaw } from 'vue-router';

const reportRoutes: Array<RouteRecordRaw> = [
  {
    path: 'report/timesheet',
    component: () =>
      import(
        '@/app/report/components/timesheet-report-v2/timesheet-report-index-component.vue'
      ),
    name: 'app.timesheet.report',
  },
  {
    path: 'report/finance',
    component: () =>
      import('@/app/report/components/finance/finance-report-index.vue'),
    name: 'app.finance.report',
  },
  {
    path: 'report/project-expense',
    component: () =>
      import(
        '@/app/report/components/project-expense/project-expense-index.vue'
      ),
    name: 'app.project-expense.report',
  },
];

export default reportRoutes;
